module.exports = __webpack_public_path__ + "static/img/pic.93c8ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneJoinUs/pic.png
// module id = gMbI
// module chunks = 0